/** Must match QuizSettings.AsyncPvPLobbyExpiryHours (API) — lobby lifetime after publication. */
export const ASYNC_PVP_LOBBY_EXPIRY_HOURS = 48;
